<template>
  <div :class="className" class="dummy-status">
    <div class="dummy-img">
      <img src="@/assets/images/img-404/img-404.svg" alt="empty">
    </div>
    <div class="dummy-info">
      <div class="dummy-title" v-html="title" />
      <div class="dummy-text" v-html="desp" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'NotFoundDummy',
  props: {
    className: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    desp: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/assets/scss/component/button.scss';

.dummy-status{
  text-align: center;
  margin: 72px 0;
  text-align: center;
  img{
    width: 80%;
    max-width: 400px;
  }
  .dummy-title{
    font-size: 24px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey-50;
    margin: 40px 0 24px;
  }
  .dummy-text{
    display: inline-block;
    max-width: 450px;
    font-size: 20px;
    font-weight: normal;
    line-height: 1.6;
    color: $grey-50;
  }
  &.abreast{
    .dummy-img{
      width: 50%;
      float: left;
      text-align: center;
    }
    .dummy-info{
      overflow: hidden;
      padding-left: 100px;
      text-align: left;
      padding-top: 50px;
    }
  }
}
</style>
<style lang="scss">

</style>
